<template>
  <div class="step-container">
    <!-- Header Section -->
    <StepHeader :currentStep="currentStep" :steps="steps" />

    <!-- Content Section -->
    <div class="content-section">
      <div class="form-sections">

        <div v-for="(brand, index) in brands" :key="index" class="brand-container">
          <div class="brand-title-container">

            
            <h4><b>{{ brand }}-{{ lang.W00050 }}</b></h4>
            <div class="apply-visits-container">
              <select v-model="visitsToApply.scenarioId" :disabled="readonly">
                <option :value="null" disabled hidden>{{ lang.W00080 }}</option>
                <option 
                  v-for="scenario in localFormData.scenarios" 
                  :key="scenario.ScenarioId"
                  :value="scenario.ScenarioId"
                >{{ scenario.ScenarioName }}</option>
              </select>
              <input type="number" :min="0" :step="1" v-model="visitsToApply.number" :disabled="readonly">
              <button class="wizard-btn-dark" @click="applyVisits(brand)" :disabled="readonly">{{ lang.W00079 }}</button>
            </div>            
          </div>

          <!-- Locations Table -->
          <div class="wizard-table-container">
            <!-- Table Header -->
            <div class="wizard-table-header">
              <div class="wizard-table-settings-container">
                <i class="material-icons cursor-pointer" @click="showTableSettings = !showTableSettings">more_vert</i>
                <div class="wizard-table-settings-list" v-if="showTableSettings">
                  <div class="wizard-table-settings-list-element" v-for="([key, value], index) in Object.entries(columns)">
                    <span style="width: max-content;">{{ value.lang ? lang[value.lang] : key }}</span>
                    <input type="checkbox" v-model="value.visible" @change="applyColumnGrid(), resetFilter(key, value.visible, brand)" :disabled="value.disabled">
                  </div>
                </div>
              </div>

              <div class="wizard-table-header-cell" v-if="columns.LocationStoreId.visible">
                {{ lang.W00035 }}
                <!-- filter -->
                <svg 
                  width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-linejoin="round" stroke-linecap="round"
                  class="wizard-table-filter-icon"
                  :class="{ 'filled': (filter[brand] && filter[brand].LocationStoreId && filter[brand].LocationStoreId.text) }"
                  @click="showFilter(brand, 'LocationStoreId')"
                >
                  <path d="M4 6h16l-6 7v5l-4-2v-3l-6-7z"/>
                </svg>
                <div class="wizard-table-filter" v-if="filter[brand] && filter[brand].LocationStoreId && filter[brand].LocationStoreId.show">
                  <input 
                    type="text" 
                    placeholder="Search" 
                    v-model="filter[brand].LocationStoreId.text" 
                    @input="applyColumnGrid(); $forceUpdate()" 
                    @blur="filter[brand].LocationStoreId.show = false; applyColumnGrid(); $forceUpdate()"
                  >                  
                </div>
              </div>
              <div class="wizard-table-header-cell" v-if="columns.LocationName.visible">
                {{ lang.W00051 }}
                <!-- filter -->
                <svg 
                  width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-linejoin="round" stroke-linecap="round"
                  class="wizard-table-filter-icon"
                  :class="{ 'filled': (filter[brand] && filter[brand].LocationName && filter[brand].LocationName.text) }"
                  @click="showFilter(brand, 'LocationName')"
                >
                  <path d="M4 6h16l-6 7v5l-4-2v-3l-6-7z"/>
                </svg>
                <div class="wizard-table-filter" v-if="filter[brand] && filter[brand].LocationName && filter[brand].LocationName.show">
                  <input 
                    type="text" 
                    placeholder="Search" 
                    v-model="filter[brand].LocationName.text" 
                    @input="applyColumnGrid(); $forceUpdate()" 
                    @blur="filter[brand].LocationName.show = false; applyColumnGrid(); $forceUpdate()"
                  >                  
                </div>
              </div>
              <div class="wizard-table-header-cell" v-if="columns.displayAddress.visible">
                {{ lang.W00052 }}
                <!-- filter -->
                <svg 
                  width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-linejoin="round" stroke-linecap="round"
                  class="wizard-table-filter-icon"
                  :class="{ 'filled': (filter[brand] && filter[brand].displayAddress && filter[brand].displayAddress.text) }"
                  @click="showFilter(brand, 'displayAddress')"
                >
                  <path d="M4 6h16l-6 7v5l-4-2v-3l-6-7z"/>
                </svg>
                <div class="wizard-table-filter" v-if="filter[brand] && filter[brand].displayAddress && filter[brand].displayAddress.show">
                  <input 
                    type="text" 
                    placeholder="Search" 
                    v-model="filter[brand].displayAddress.text" 
                    @input="applyColumnGrid(); $forceUpdate()" 
                    @blur="filter[brand].displayAddress.show = false; applyColumnGrid(); $forceUpdate()"
                  >                  
                </div>
              </div>
              <div class="wizard-table-header-cell" v-if="columns.Brand.visible">
                {{ "Brand" }}
                <!-- filter -->
                <svg 
                  width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-linejoin="round" stroke-linecap="round"
                  class="wizard-table-filter-icon"
                  :class="{ 'filled': (filter[brand] && filter[brand].Brand && filter[brand].Brand.text) }"
                  @click="showFilter(brand, 'Brand')"
                >
                  <path d="M4 6h16l-6 7v5l-4-2v-3l-6-7z"/>
                </svg>
                <div class="wizard-table-filter" v-if="filter[brand] && filter[brand].Brand && filter[brand].Brand.show">
                  <input 
                    type="text" 
                    placeholder="Search" 
                    v-model="filter[brand].Brand.text" 
                    @input="applyColumnGrid(); $forceUpdate()" 
                    @blur="filter[brand].Brand.show = false; applyColumnGrid(); $forceUpdate();"
                  >                  
                </div>
              </div>

              <div class="wizard-table-header-cell" v-if="columns.Countries.visible">
                {{ "Countries" }}
                <!-- filter -->
                <svg 
                  width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-linejoin="round" stroke-linecap="round"
                  class="wizard-table-filter-icon"
                  :class="{ 'filled': (filter[brand] && filter[brand].Countries && filter[brand].Countries.text) }"
                  @click="showFilter(brand, 'Countries')"
                >
                  <path d="M4 6h16l-6 7v5l-4-2v-3l-6-7z"/>
                </svg>
                <div class="wizard-table-filter" v-if="filter[brand] && filter[brand].Countries && filter[brand].Countries.show">
                  <input 
                    type="text" 
                    placeholder="Search" 
                    v-model="filter[brand].Countries.text" 
                    @input="applyColumnGrid(); $forceUpdate()" 
                    @blur="filter[brand].Countries.show = false; applyColumnGrid(); $forceUpdate();"
                  >                  
                </div>
              </div>

              <div class="wizard-table-header-cell" v-if="columns.Checkanlage.visible">
                {{ "Checkanlage" }}
                <!-- filter -->
                <svg 
                  width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-linejoin="round" stroke-linecap="round"
                  class="wizard-table-filter-icon"
                  :class="{ 'filled': (filter[brand] && filter[brand].Checkanlage && filter[brand].Checkanlage.text) }"
                  @click="showFilter(brand, 'Checkanlage')"
                >
                  <path d="M4 6h16l-6 7v5l-4-2v-3l-6-7z"/>
                </svg>
                <div class="wizard-table-filter" v-if="filter[brand] && filter[brand].Checkanlage && filter[brand].Checkanlage.show">
                  <input 
                    type="text" 
                    placeholder="Search" 
                    v-model="filter[brand].Checkanlage.text" 
                    @input="applyColumnGrid(); $forceUpdate()" 
                    @blur="filter[brand].Checkanlage.show = false; applyColumnGrid(); $forceUpdate();"
                  >                  
                </div>
              </div>

              <div class="wizard-table-header-cell" v-if="columns.Checkanlage2.visible">
                {{ "Checkanlage2" }}
                <!-- filter -->
                <svg 
                  width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-linejoin="round" stroke-linecap="round"
                  class="wizard-table-filter-icon"
                  :class="{ 'filled': (filter[brand] && filter[brand].Checkanlage2 && filter[brand].Checkanlage2.text) }"
                  @click="showFilter(brand, 'Checkanlage2')"
                >
                  <path d="M4 6h16l-6 7v5l-4-2v-3l-6-7z"/>
                </svg>
                <div class="wizard-table-filter" v-if="filter[brand] && filter[brand].Checkanlage2 && filter[brand].Checkanlage2.show">
                  <input 
                    type="text" 
                    placeholder="Search" 
                    v-model="filter[brand].Checkanlage2.text" 
                    @input="applyColumnGrid(); $forceUpdate()" 
                    @blur="filter[brand].Checkanlage2.show = false; applyColumnGrid(); $forceUpdate();"
                  >                  
                </div>
              </div>

              <div class="wizard-table-header-cell" v-if="columns.Checkanlage3.visible">
                {{ "Checkanlage3" }}
                <!-- filter -->
                <svg 
                  width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-linejoin="round" stroke-linecap="round"
                  class="wizard-table-filter-icon"
                  :class="{ 'filled': (filter[brand] && filter[brand].Checkanlage3 && filter[brand].Checkanlage3.text) }"
                  @click="showFilter(brand, 'Checkanlage3')"
                >
                  <path d="M4 6h16l-6 7v5l-4-2v-3l-6-7z"/>
                </svg>
                <div class="wizard-table-filter" v-if="filter[brand] && filter[brand].Checkanlage3 && filter[brand].Checkanlage3.show">
                  <input 
                    type="text" 
                    placeholder="Search" 
                    v-model="filter[brand].Checkanlage3.text" 
                    @input="applyColumnGrid(); $forceUpdate()" 
                    @blur="filter[brand].Checkanlage3.show = false; applyColumnGrid(); $forceUpdate();"
                  >                  
                </div>
              </div>
              <div class="wizard-table-header-cell">
                {{ lang.W00053 }}
              </div>
            </div>

            <!-- Table Body -->
            <div class="wizard-table-body">
              <div
                v-for="location in getLocationsOfBrand(brand)"
                :key="location.id"
                class="wizard-table-row"
              >
                <!-- ID -->
                <div class="wizard-table-cell" v-if="columns.LocationStoreId.visible">{{ location.LocationStoreId }}</div>

                <!-- Name -->
                <div class="wizard-table-cell" v-if="columns.LocationName.visible">{{ location.LocationName }}</div>

                <!-- City -->
                <div class="wizard-table-cell" v-if="columns.displayAddress.visible">{{ location.displayAddress }}</div>

                <!-- Brand -->
                <div class="wizard-table-cell" v-if="columns.Brand.visible">{{ location.Brand }}</div>

                <!-- Countries -->
                <div class="wizard-table-cell" v-if="columns.Countries.visible">{{ location.Countries }}</div>

                <!-- Checkanlage -->
                <div class="wizard-table-cell" v-if="columns.Checkanlage.visible">{{ location.Checkanlage }}</div>

                <!-- Checkanlage 2 -->
                <div class="wizard-table-cell" v-if="columns.Checkanlage2.visible">{{ location.Checkanlage2 }}</div>

                <!-- Checkanlage 3 -->
                <div class="wizard-table-cell" v-if="columns.Checkanlage3.visible">{{ location.Checkanlage3 }}</div>

                <!-- Scenario -->
                <div class="wizard-table-cell">
                  <div v-for="scenario in localFormData.scenarios" class="scenario-input">
                    <span>{{ scenario.ScenarioName }}</span>
                    <input 
                      class="wizard-input"
                      type="number" 
                      :min="0" 
                      :step="1" 
                      :value="getNumberOfVisits(location.LocationId, scenario.ScenarioId)"
                      @change="setNumberOfVisits(location.LocationId, scenario.ScenarioId, $event)"
                      :disabled="readonly"
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
          
          <div class="brand-computed-data" v-for="bv in brandVisits" v-if="bv.brand == brand">
            <span><b>{{ lang.W00072 }} {{ bv.checkCount }}</b></span>
            <span><b>{{ lang.W00073 }} {{ bv.locationsWithChecksCount }}</b></span>
            <span v-for="scenario in bv.scenarios"><b>{{ scenario.scenarioName }}: {{ scenario.checkCount }}</b></span>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import "../../../styles/audi-steps.css";
import StepHeader from './StepHeader.vue';
import wizardService from "../../../services/WizardService";

export default {
  name: 'Step6',
  components: {
    StepHeader
  },
  props: {
    formData: { type: Object, required: true },
    currentStep: { type: Number, default: 0 },
    steps: { type: Array, required: true },
    readonly: { type: Boolean, default: false }
  },
  data() {
    return {
      localFormData: structuredClone(this.formData),
      locations: null,
      brands: null,
      recompute: 0,
      visitsToApply: {
        scenarioId: null,
        number: 0
      },
      filter: {},
      showTableSettings: false,
      columns: {
        LocationStoreId: { 
          visible: true,
          width: "1fr",
          disabled: false,
          lang: "W00035"
        },
        LocationName: { 
          visible: true,
          width: "1fr",
          disabled: false,
          lang: "W00051"
        },
        displayAddress: { 
          visible: true,
          width: "1fr",
          disabled: false,
          lang: "W00052"
        },
        Brand: { 
          visible: false,
          width: "1fr",
          disabled: false,
          lang: null
        },
        Countries: { 
          visible: false,
          width: "1fr",
          disabled: false,
          lang: null
        },
        Checkanlage: { 
          visible: false,
          width: "1fr",
          disabled: false,
          lang: null
        },
        Checkanlage2: { 
          visible: false,
          width: "1fr",
          disabled: false,
          lang: null
        },
        Checkanlage3: { 
          visible: false,
          width: "1fr",
          disabled: false,
          lang: null
        },
        Scenarios: { 
          visible: true,
          width: "2fr",
          disabled: true,
          lang: "W00053"
        },
      },
      lang: {
        W00035: "ID",
        W00050: "Locations",
        W00051: "Location",
        W00052: "Address",
        W00053: "Number of checks per scenario",

        W00072: "Checks total:",
        W00073: "Locations with checks:",
        W00074: "Checks for scenario \"PLACEHOLDER\":",

        W00079: "Apply on all",
        W00080: "Select scenario...",
      }
    }
  },
  computed: {
    brandVisits() {
      this.recompute; // force recompute on change of variable this.recompute

      let res = [];
      for (const brand of this.brands) {
        let o = {
          "brand": brand,
          "checkCount": this.getCheckCountByBrand(brand),
          "locationsWithChecksCount": this.getLocationsWithChecksCountByBrand(brand),
        }
        if(!this.localFormData.scenarios) continue;
        o.scenarios = [];
        for (const scenario of this.localFormData.scenarios) {
          let s = {
            "scenarioName": scenario.ScenarioName,
            "checkCount": this.getCheckCountByBrandAndScenario(brand, scenario.ScenarioId)
          };
          o.scenarios.push(s);
        }
        res.push(o);
      }
      return res;
    }
  },
  watch: {
    "formData": {
      deep: true,
      handler() {
        this.localFormData = structuredClone(this.formData);
      }
    },
    "localFormData": {
      deep: true,
      handler(newVal) {
        this.$emit('update:formData', newVal);
      }
    },
    "globals.selectedLanguage"() {
      this.globals.getLanguageStrings(this);
    },
  },
  mounted() {
    if (this.globals.selectedLanguage) { 
      this.globals.getLanguageStrings(this);
    }
    this.readConfigurationLocations();
  },
  methods: {
    resetFilter(column, visible, brand) {
      if(!visible) {
        for (const [key, brandFilter] of Object.entries(this.filter)) {
          console.log(brandFilter)
          console.log(column)
          console.log(brandFilter[column])
          if(brandFilter[column]) {
            delete brandFilter[column];
            console.log(brandFilter)
          }          
        }
      }
    },
    applyColumnGrid() {
      // set timeout, cause newly rendered columns will have default grid template
      setTimeout(() => {
        let gridTemplate = "";
        for (const [key, value] of Object.entries(this.columns)) {
          if(value.visible) gridTemplate += `${value.width} `;
        }
        let headers = document.getElementsByClassName("wizard-table-header");
        for (const e of headers) {
          e.style.gridTemplateColumns = gridTemplate;
        }
        let rows = document.getElementsByClassName("wizard-table-row");
        for (const e of rows) {
          e.style.gridTemplateColumns = gridTemplate;
        }
      }, 100);
    },
    showFilter(brand, type) {
      if(!this.filter[brand]) this.filter[brand] = { [type]: { show: true, text: "" }};
      else if(!this.filter[brand][type]) this.filter[brand][type] = { show: true, text: "" };
      else if (!this.filter[brand][type].show) this.filter[brand][type].show = true;
      else if (this.filter[brand][type].show) this.filter[brand][type].show = false;
      this.$forceUpdate();
    },
    applyVisits(brand) {
      if(!this.visitsToApply.scenarioId) return;

      let locations = this.getLocationsOfBrand(brand);
      let fakeEvent = { "target": {"valueAsNumber": this.visitsToApply.number }};
      for (const location of locations) {
        this.setNumberOfVisits(location.LocationId, this.visitsToApply.scenarioId, fakeEvent);
      }
    },
    getCheckCountByBrand(brand) {
      if(!this.localFormData || !this.localFormData.visits) return 0;
      let count = 0;
      for (const visit of this.localFormData.visits) {
        let location = this.locations.find(e => e.LocationId == visit.LocationId);
        if(!location || location.Brand != brand) continue;
        count += Number(visit.NumberOfVisits);
      }
      return count;
    },
    getLocationsWithChecksCountByBrand(brand) {
      if(!this.localFormData || !this.localFormData.visits) return 0;
      let locations = [];
      for (const visit of this.localFormData.visits) {
        let location = this.locations.find(e => e.LocationId == visit.LocationId);
        if(!location || location.Brand != brand) continue;

        if(!locations.includes(location.LocationId)) locations.push(location.LocationId)
      }
      return locations.length;
    },
    getCheckCountByBrandAndScenario(brand, scenarioId) {
      if(!this.localFormData || !this.localFormData.visits) return 0;
      let count = 0;
      for (const visit of this.localFormData.visits) {
        if(visit.ScenarioId != scenarioId) continue;
        let location = this.locations.find(e => e.LocationId == visit.LocationId);
        if(!location || location.Brand != brand) continue;
        count += Number(visit.NumberOfVisits);
      }
      return count;
    },
    setNumberOfVisits(locationId, scenarioId, event) {
      this.recompute++;
      if(!this.localFormData.visits) this.$set(this.localFormData, 'visits', []);

      if(event && event.target) {
        let visit = this.localFormData.visits.find(e => e.LocationId == locationId && e.ScenarioId == scenarioId);
        if(visit) {
          if(!event.target.valueAsNumber) {
            this.localFormData.visits = this.localFormData.visits.filter(e => e != visit);
          } else {
            visit.NumberOfVisits = event.target.valueAsNumber;            
          }
        } else if (event.target.valueAsNumber) {
          this.localFormData.visits.push({
            "LocationId": locationId,
            "ScenarioId": scenarioId,
            "NumberOfVisits": event.target.valueAsNumber
          })
        }
      }
    },
    getNumberOfVisits(locationId, scenarioId) {
      if(!this.localFormData.visits) return null;
      let e = this.localFormData.visits.find(e => e.LocationId == locationId && e.ScenarioId == scenarioId)
      if(e && e.NumberOfVisits) return e.NumberOfVisits;
      return null;
    },
    getLocationsOfBrand(brand) {
      if(!this.locations) return [];
      let res = this.locations.filter(e => e.Brand == brand)
      const brandFilter = this.filter[brand];
      if (!brandFilter) return res;

      res = res.filter(loc => {
        return Object.entries(brandFilter).every(([key, filterVal]) => {
          if (filterVal == null || filterVal === "") {
            return true;
          }

          const locVal = loc[key];

          if (typeof filterVal === "object" && filterVal.text != null) {
            if (typeof locVal !== "string") return false;
            return locVal.toLowerCase().includes(filterVal.text.toLowerCase());
          }

          return locVal === filterVal;
        });
      });

      return res;
    },
    async readConfigurationLocations() {
      let res = await wizardService.readConfigurationLocations(this.localFormData.configurationGuid);
      for (const location of res) {
        location.displayAddress = `${location.LocationAddress}\n${location.LocationPostalCode} ${location.LocationCity}`;
      }
      if(res) this.locations = res;
      this.brands = [...new Set(this.locations.map(e => e.Brand))];
    },
    validateStep() {
      if(!this.localFormData.visits || this.localFormData.visits.length <= 0) return { valid: false, msg: "Please choose at least one location."};
      return { valid: true, msg: null};
    },
  }
}
</script>

<style lang="css" scoped>
.form-sections {
  display: flex;
  flex-direction: column;
  gap: 32px;
}

.wizard-table-header {
  grid-template-columns: 1fr 1fr 1fr 2fr;
}
.wizard-table-row {
  grid-template-columns: 1fr 1fr 1fr 2fr;
}
.wizard-input {
  border-bottom: 1px solid #e0e0e0;
}

.scenario-input {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.scenario-input span {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.brand-computed-data {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-around;
  flex-wrap: wrap;
  row-gap: 10px;
  padding: 10px;
  background-color: #f8f9fa;
  border-bottom: 2px solid #e0e0e0;
  border-left: 2px solid #e0e0e0;
  border-right: 2px solid #e0e0e0;
  min-width: 900px;
}
.brand-computed-data span {
  flex-basis: 20%;
}

.brand-container {
  width: 100%;
}
.brand-title-container {
  display: flex;
  flex-direction: column;
  position: relative;
}

.apply-visits-container {
  position: absolute;
  right: 0px;
  display: flex;
  flex-direction: row;
}
.apply-visits-container select {
  border: 1px solid gray;
  border-right: none;
  border-radius: 6px 0px 0px 6px;
  height: 30px;
}
.apply-visits-container input {
  border: 1px solid gray;
  border-right: none;
  border-radius: 0px;
  height: 30px;
  width: 80px;
  text-align: center;
}
.apply-visits-container button {
  border-radius: 0px 6px 6px 0px;
  height: 30px;
}

.wizard-table-settings-container {
  position: absolute;
  top: 10px;
  left: 10px;
  display: flex;
  flex-direction: row;
  z-index: 2;
}
.wizard-table-settings-list {
  position: absolute;
  display: flex;
  flex-direction: column;
  background: #f8f9fa;
  border: 1px solid #e0e0e0;
  z-index: 2;
  transform: translate(30px, 12px);
  padding: 5px;
  box-shadow: 0px 5px 5px rgb(0 0 0 / 20%);
}
.wizard-table-settings-list-element {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  gap: 10px;
}
</style>



// WEBPACK FOOTER //
// Step6.vue?c3f12b82